import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Music, CheckCircle2, XCircle } from "lucide-react";
import axios from "axios";
import { API_BASE } from "../lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); setMessage("No confirmation link found."); return; }
    axios.get(`${API_BASE}/auth/verify-email?token=${token}`)
      .then(() => setState("ok"))
      .catch((e) => { setState("error"); setMessage(e?.response?.data?.detail || "That link didn't work."); });
  }, [params]);

  return (
    <div className="min-h-screen bg-[#0B192C] text-[#FAF7EE] flex items-center justify-center px-5" data-testid="verify-page">
      <div className="w-full max-w-sm text-center">
        <Music className="w-8 h-8 text-[#C69B3D] mx-auto" aria-hidden />
        {state === "loading" && <p className="mt-4 text-[#FAF7EE]/70">Confirming your email…</p>}
        {state === "ok" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[#2D6A4F] mx-auto mt-4" aria-hidden />
            <h1 className="font-display text-2xl font-bold mt-3" data-testid="verify-success">Email confirmed</h1>
            <p className="text-sm text-[#FAF7EE]/70 mt-2">You're all set — your staff account is fully active.</p>
            <Link to="/staff" data-testid="verify-signin"
              className="mt-6 inline-block px-6 py-4 rounded-2xl bg-[#C69B3D] text-[#0B192C] font-bold min-h-[52px]">
              Sign in
            </Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-12 h-12 text-[#A62B2B] mx-auto mt-4" aria-hidden />
            <h1 className="font-display text-2xl font-bold mt-3" data-testid="verify-error">{message}</h1>
            <Link to="/staff" className="mt-6 inline-block text-[#C69B3D] underline">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
